import { Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { trackWhatsAppClick, trackCallClick, trackEmailClick } from "@/lib/analytics";
import WhatsAppIcon from "@/components/WhatsAppIcon";

interface Props {
  trigger: React.ReactNode;
  whatsappText?: string;
  emailSubject?: string;
  emailBody?: string;
  align?: "start" | "center" | "end";
  side?: "top" | "bottom" | "left" | "right";
  showFormLink?: boolean;
}

const PHONE = "+34644100551";
const EMAIL = "sercom.construction@gmail.com";

export default function ContactPopover({
  trigger,
  whatsappText = "Hola, me interesan vuestras propiedades",
  emailSubject = "Interés por una casa",
  emailBody = "Hola,\n\nHe visto una de vuestras casas en la web de Sercom y me gustaría recibir más información o, si fuera posible, concertar una visita.\n\nQuedo a la espera de vuestra respuesta.\n\nUn saludo.",
  align = "center",
  side = "bottom",
  showFormLink = false,
}: Props) {
  const waHref = `https://wa.me/34644100551?text=${encodeURIComponent(whatsappText)}`;
  const mailHref = `mailto:${EMAIL}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;

  return (
    <Popover>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent align={align} side={side} sideOffset={12} className="glass-surface apple-shadow w-64 rounded-xl p-2">
        <a
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick()}
          className="flex items-center gap-3 rounded-md px-3 py-2.5 text-foreground transition-colors hover:bg-muted/70"
        >
          <WhatsAppIcon className="h-6 w-6" />
          <span className="text-sm font-medium">WhatsApp</span>
        </a>
        <a
          href={`tel:${PHONE}`}
          onClick={() => trackCallClick()}
          className="flex items-center gap-3 rounded-md px-3 py-2.5 text-foreground transition-colors hover:bg-muted/70"
        >
          <Phone className="w-4 h-4 text-accent" />
          <span className="text-sm font-medium">Llamar</span>
        </a>
        <a
          href={mailHref}
          onClick={() => trackEmailClick()}
          className="flex items-center gap-3 rounded-md px-3 py-2.5 text-foreground transition-colors hover:bg-muted/70"
        >
          <Mail className="w-4 h-4 text-accent" />
          <span className="text-sm font-medium">Email</span>
        </a>
        {showFormLink && (
          <>
            <div className="my-1 border-t border-border/60" />
            <Link
              to="/Contacto"
              className="flex items-center gap-3 rounded-md px-3 py-2.5 text-foreground transition-colors hover:bg-muted/70"
            >
              <ArrowRight className="w-4 h-4 text-accent" />
              <span className="text-sm font-medium">Dejar mis datos</span>
            </Link>
          </>
        )}
      </PopoverContent>
    </Popover>
  );
}
